import React from 'react'

import { Absolute } from '../helpers/Position'
import { HorizontalLine } from '../shapes/Line'
import { Title } from '../presentation/Text'
import FlexGrid from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Panel from '../structure/Panel'
import Scroll from '../helpers/Scroll'
import SeparatorWrapper from '../helpers/SeparatorWrapper'
import { COLORS } from '@btime/constants'

const PanelHeader = ({ title, icon, hideSeparator, onClick }) => (
  <Link block onClick={onClick}>
    <SeparatorWrapper weight={3} usePadding>
      <FlexGrid justify="space-between" gutter=".4" align="center">
        <Title size="h6">{title}</Title>
        <Icon name={icon} size="1rem" color={COLORS.dark3} />
      </FlexGrid>
    </SeparatorWrapper>
    {!hideSeparator && <HorizontalLine thin lineColor={COLORS.light2} />}
  </Link>
)

const MapPanelWrapper = ({ title, headerIcon, onHeaderClick, children, left, right, scroll, hasContent, ...props }) => {
  hasContent = hasContent === undefined ? !!children : hasContent

  const positionParams = {
    top: '0',
    ...(right ? { right } : {}),
    ...(left ? { left } : {})
  }

  return (
    <Absolute {...positionParams}>
      <Panel noPadding {...props}>
        <PanelHeader title={title} icon={headerIcon} onClick={onHeaderClick} hideSeparator={!hasContent} />
        {hasContent && <Scroll maxHeight="calc(100vh - 16rem)">{children}</Scroll>}
      </Panel>
    </Absolute>
  )
}

export default MapPanelWrapper
